export default __webpack_public_path__ + "static/media/CZF.d572a9e3.png";